import React from 'react';
import _times from 'lodash/times';
import styled from 'styled-components';

import { ProductCardLoadingSkeleton, LoadingSkeleton } from 'components/core';
import CarouselSlider from 'components/carousel-slider';
import { CardCarouselItem, dimensions, GroupHeader, Section } from 'src/components/carousels';

const ProductSkeletonCarousel = (props) => (
  <Section noBorder {...props}>
    <GroupHeader>
      <LoadingSkeleton width={183} height={13} />
    </GroupHeader>
    <CarouselSlider>
      {_times(6, (key) => (
        <CardCarouselItem key={key}>
          {/* eslint-disable-next-line i18next/no-literal-string */}
          <ProductCardLoadingSkeleton cardSize='large' dimensions={dimensions} />
        </CardCarouselItem>
      ))}
    </CarouselSlider>
    <StyledLine />
  </Section>
);

export default ProductSkeletonCarousel;

const StyledLine = styled.hr`
  background-color: ${({ theme }) => theme.colors.blueGrey[90]};
  height: 1px;
  border: none;
  margin: 30px 0 0;
`;
